import App from './App.svelte'
import { createClient } from '@supabase/supabase-js'

const SUPABASE_KEY = process.env.SUPABASE_KEY
const SUPABASE_URL = process.env.SUPABASE_URL

window.supabase = createClient(SUPABASE_URL, SUPABASE_KEY)

const app = new App({
	target: document.body,
	props: {
		name: 'world'
	}
})

export default app;